module.exports = __webpack_public_path__ + "assets/logo.cae854fe81cd53fc5bd8def934397d98.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/logo.png
 ** module id = 370
 ** module chunks = 0
 **/